<div class="avi-hover-overlay">
    <ng-content></ng-content>
</div>
